module.exports = __webpack_public_path__ + "img/recentl_ycreated.3ed5c549.svg";